import { func, number, oneOf } from 'prop-types'

import StarIcon from 'views/components/atoms/StarIcon'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import { ICON_SIZE } from 'views/consts'

import { MAX_RATING } from './consts'

// eslint-disable-next-line react/prop-types
const Star = ({ name, index, iconSize, onClick, filled }) => {
  const className = filled ? 'm-StarRating__star-on qa-star-on' : 'qa-star-off'

  if (!onClick) {
    return (
      <li className={className}>
        <StarIcon filled={filled} size={iconSize} />
      </li>
    )
  } else {
    return (
      <li className={className}>
        <ButtonAsLink name={name} onClick={() => onClick(index + 1)}>
          <StarIcon filled={filled} size={iconSize} />
        </ButtonAsLink>
      </li>
    )
  }
}

const Stars = ({ rating, iconSize, onClick }) => {
  const stars = []
  // handle float rating values
  const ratingRounded = Math.round(rating)
  let filled = true

  for (let i = 0; i < MAX_RATING; i += 1) {
    if (i === ratingRounded) {
      filled = false
    }
    const key = filled ? `star-rating-filled-${i}` : `star-rating-empty-${i}`

    stars.push(
      <Star
        key={key}
        name={key}
        index={i}
        iconSize={iconSize}
        onClick={onClick}
        filled={filled}
      />
    )
  }
  return stars
}

Stars.propTypes = {
  rating: number.isRequired,
  iconSize: oneOf(ICON_SIZE),
  onClick: func,
}

Stars.defaultProps = {
  iconSize: 'small',
  onClick: null,
}

export default Stars
